// depositum-reservation.js
(function() {
  if (!window.location.pathname.startsWith('/products/')) return;

  const DEPOSITUM_TABEL = [
    [29999,  '53344464601424'],
    [49999,  '53344469746000'],
    [74999,  '53344469778768'],
    [99999,  '53344469811536'],
    [149999, '53344469844304'],
    [199999, '53344469877072'],
    [249999, '53344469909840'],
    [300000, '53344469942608'],
  ];

  function findVariantId(bilPrisKr) {
    for (const [max, variantId] of DEPOSITUM_TABEL) {
      if (bilPrisKr <= max) return variantId;
    }
    return DEPOSITUM_TABEL[DEPOSITUM_TABEL.length - 1][1];
  }

  function formaterPris(kr) {
    return kr.toLocaleString('da-DK') + ' kr.';
  }

  const bilPrisOere = window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price
    || document.querySelector('[data-product-price]')?.dataset?.productPrice;

  if (!bilPrisOere) return;

  const bilPrisKr = Math.round(parseInt(bilPrisOere) / 100);
  const variantId = findVariantId(bilPrisKr);
  const depositumKr = bilPrisKr <= 29999 ? 8000
    : bilPrisKr <= 49999 ? 10000
    : bilPrisKr <= 74999 ? 12000
    : bilPrisKr <= 99999 ? 14000
    : bilPrisKr <= 149999 ? 16000
    : bilPrisKr <= 199999 ? 18000
    : bilPrisKr <= 249999 ? 19000
    : 20000;

  const restbeloebKr = bilPrisKr - depositumKr;

  // Skjul original købs-formular
  const style = document.createElement('style');
  style.textContent = `
    .product-form__buttons,
    .shopify-payment-button,
    quantity-input-wrapper {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  // Tjek om bilen er reserveret via tag
  const tags = window.ShopifyAnalytics?.meta?.product?.tags || [];
const erReserveret = document.querySelector('product-information')?.closest('[data-product]')?.dataset?.productTags?.includes('reserveret') 
  || document.documentElement.innerHTML.includes('"reserveret"');

  const bilNavn = document.querySelector('h1')?.innerText || document.title;
  const knap = document.createElement('div');

  if (erReserveret) {
    // Vis "Reserveret"-banner i stedet for knap
    knap.innerHTML = `
      <div id="bakkens-reservation" style="margin-top:20px;">
        <div style="background:#c0392b;border-radius:6px;padding:16px;text-align:center;margin-bottom:12px;">
          <p style="color:#fff;font-weight:bold;font-size:1.1em;margin:0;letter-spacing:1px;">🔒 DENNE BIL ER RESERVERET</p>
        </div>
        <p style="font-size:0.85em;color:#aaa;text-align:center;margin:0;">
          Bilen er reserveret af en anden køber. Kontakt os hvis du har spørgsmål.<br>
          📞 <a href="tel:+4525786370" style="color:#aaa;">+45 25 78 63 70</a>
        </p>
      </div>
    `;
  } else {
    // Vis normal reservationsknap med checkbox
    knap.innerHTML = `
      <div id="bakkens-reservation" style="margin-top:20px;">
      <p style="font-size:0.9em;color:#888;margin-bottom:12px;">
        Depositum: <strong style="color:#555;">${formaterPris(depositumKr)}</strong>
        &nbsp;·&nbsp; Modregnes i den endelige købssum
      </p>
        <label style="display:flex;align-items:flex-start;gap:10px;margin-bottom:12px;cursor:pointer;font-size:0.85em;color:#aaa;">
          <input type="checkbox" id="accept-betingelser" style="margin-top:3px;accent-color:#c0392b;width:16px;height:16px;flex-shrink:0;">
<span style="color:#000;">Jeg har læst og accepterer <a href="/pages/handelsbetingelser" target="_blank" style="color:#0066cc;text-decoration:underline;font-weight:bold;">handelsbetingelserne</a></span>
        </label>
        <button id="reserver-bil-knap"
           style="display:block;width:100%;padding:14px;background:#888;color:#fff;
                  text-align:center;font-weight:bold;font-size:1em;border-radius:4px;
                  border:none;cursor:not-allowed;letter-spacing:0.5px;transition:background 0.2s;">
          Reservér bil
        </button>
      </div>
    `;
  }

  const target = document.querySelector('.product-form__buttons, .product-form, form[action="/cart/add"]');
  if (target) target.insertAdjacentElement('afterend', knap);

  if (!erReserveret) {
    const checkbox = document.getElementById('accept-betingelser');
    const reserverKnap = document.getElementById('reserver-bil-knap');

    checkbox.addEventListener('change', function() {
      if (this.checked) {
        reserverKnap.style.background = '#c0392b';
        reserverKnap.style.cursor = 'pointer';
      } else {
        reserverKnap.style.background = '#888';
        reserverKnap.style.cursor = 'not-allowed';
      }
    });

    reserverKnap.addEventListener('click', async function() {
      if (!checkbox.checked) return;
      this.textContent = 'Vent...';
      this.disabled = true;
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              'Bil': bilNavn,
              'Bilens pris': formaterPris(bilPrisKr),
              'Depositum': formaterPris(depositumKr),
              'Restbeløb ved afhentning': formaterPris(restbeloebKr)
            }
          })
        });
        window.location.href = '/checkout';
      } catch(e) {
        this.textContent = 'Reservér bil';
        this.disabled = false;
        alert('Der opstod en fejl. Prøv igen.');
      }
    });
  }
})();
